// redux/features/TabsManager/tabSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openTabs: [], // [{ title, path, component, isPinned }]
  activeTab: null,
  tabHistory: [], // almacena los paths en orden de uso
};

const reorderTabs = (tabs) => {
  const pinned = tabs.filter((t) => t.isPinned);
  const unpinned = tabs.filter((t) => !t.isPinned);
  return [...pinned, ...unpinned];
};

const tabSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    addTab: (state, action) => {
      const exists = state.openTabs.find(
        (tab) => tab.path === action.payload.path
      );
      if (!exists) {
        state.openTabs.push(action.payload);
        state.openTabs = reorderTabs(state.openTabs);
      }
      state.activeTab = action.payload;
      // actualizar historial
      state.tabHistory = state.tabHistory.filter(
        (p) => p !== action.payload.path
      );
   
      state.tabHistory.push(action.payload.path);
    },
    addTabWithoutActive: (state, action) => {
      const exists = state.openTabs.find(
        (tab) => tab.path === action.payload.path
      );
      if (!exists) {
        state.openTabs.push(action.payload);
        state.openTabs = reorderTabs(state.openTabs);
      }
     
      // actualizar historial
      state.tabHistory = state.tabHistory.filter(
        (p) => p !== action.payload.path
      );
      state.tabHistory.push(action.payload.path);
    },
    addTabPinned: (state, action) => {
      const exists = state.openTabs.find(
        (tab) => tab.path === action.payload.path
      );
      if (!exists) {
        state.openTabs.push(action.payload);
        state.openTabs = reorderTabs(state.openTabs);
      }else{
        exists.isPinned = true;
      }
      // actualizar historial
      state.tabHistory = state.tabHistory.filter(
        (p) => p !== action.payload.path
      );
      state.tabHistory.push(action.payload.path);
    },
    setActiveTab: (state, action) => {
      const tab = state.openTabs.find((t) => t.path === action.payload);
      if (tab) {
        state.activeTab = tab;

        // actualizar historial
        state.tabHistory = state.tabHistory.filter((p) => p !== tab.path);
        state.tabHistory.push(tab.path);
      }
    },

    pinOrUnPinTab: (state, action) => {
      const { path, isPinned } = action.payload;
      const tab = state.openTabs.find((t) => t.path === path);
      if (tab) {
        tab.isPinned = isPinned;
        state.openTabs = reorderTabs(state.openTabs);
      }
    },

    closeTab: (state, action) => {
      const path = action.payload;
      state.openTabs = state.openTabs.filter((tab) => tab.path !== path);
      state.tabHistory = state.tabHistory.filter((p) => p !== path);

      if (state.activeTab?.path === path) {
        const lastPath = [...state.tabHistory]
          .reverse()
          .find((p) => state.openTabs.some((t) => t.path === p));

        state.activeTab =
          state.openTabs.find((t) => t.path === lastPath) || null;
      }
    },

    clearActiveTab: (state) => {
      state.activeTab = null;
    },

    resetTabs: () => initialState,
  },
});

export const {
  addTab,
  setActiveTab,
  closeTab,
  resetTabs,
  clearActiveTab,
  pinOrUnPinTab,
  addTabPinned,
  addTabWithoutActive
} = tabSlice.actions;

export default tabSlice.reducer;
